import { render, staticRenderFns } from "./OrganizationSubjectInput.vue?vue&type=template&id=6c6d9b6e"
import script from "./OrganizationSubjectInput.vue?vue&type=script&lang=js"
export * from "./OrganizationSubjectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports